import { useMemo } from 'react';
import { useFetchConversations } from '../../hooks/data-fetching/useFetchConversations';
import useHasPermission from '../../hooks/useHasPermission';
import { groupByKey, calculateTextingStatus } from '../../utils/texting';

export function injectConversations(Component) {
  function HOC(props) {
    const customerIds = useMemo(
      () => props.priorResidents.map((r) => r.customerIds).flat(),
      [props.priorResidents],
    );

    const hasCommunicationCreatePermission = useHasPermission(
      'communication-create',
    );
    const showTextingColumn =
      props.selectedProperty.isTwoWayCommunicationActive &&
      hasCommunicationCreatePermission;

    const [conversations] = useFetchConversations(
      customerIds,
      showTextingColumn,
    );

    const householdConversationsStatusDictionary = useMemo(() => {
      const conversationsDictionary = groupByKey(
        conversations,
        (c) => c.recipient.customerId,
      );

      return props.priorResidents.reduce((acc, priorResident) => {
        acc[priorResident.residentId] = calculateTextingStatus(
          priorResident.customerIds,
          conversationsDictionary,
        );

        return acc;
      }, {});
    }, [conversations, props.priorResidents]);

    return (
      <Component
        householdConversationsStatusDictionary={
          householdConversationsStatusDictionary
        }
        showTextingColumn={showTextingColumn}
        {...props}
      />
    );
  }

  return HOC;
}
